import React from "react";

function BS4_JS_Tab() {
  return (
    <div>
      <h1>BS4_JS_Tab Component</h1>
      <p>This is the BS4_JS_Tab tutorial page content.</p>
    </div>
  );
}

export default BS4_JS_Tab;
